export var DEPLOYMENT_STATUS;
(function (DEPLOYMENT_STATUS) {
    DEPLOYMENT_STATUS["ACTIVE"] = "active";
    DEPLOYMENT_STATUS["CREATED"] = "created";
    DEPLOYMENT_STATUS["COMPLETED"] = "completed";
    DEPLOYMENT_STATUS["FAILED"] = "failed";
})(DEPLOYMENT_STATUS || (DEPLOYMENT_STATUS = {}));
